"use client"
import styled from "styled-components";
import {useSelector} from "react-redux";
import {SIZES} from "@/components/constants";
import {useEffect, useRef, useState} from "react";
import {useMediaQuery} from "react-responsive";
import {useGetCategoryQuery} from "@/api/categoryApi";
import {useLocale} from "next-intl";
import {buildCateChange, customData} from "@/components/category/util";
import {useRouter} from "@/i18n/navigation";
import { IoIosArrowRoundForward } from "react-icons/io";



const SolutionClient = () => {
    const locale = useLocale();
    const router = useRouter();
    const isTablet = useMediaQuery(
        { query: `(max-width: ${SIZES.TABLET})` },
        undefined,
        () => false
    );
    const [activeIndex, setActiveIndex] = useState(-1);
    const boxRefs = useRef([]);
    const isPc = !isTablet;
    const { data, isLoading } = useGetCategoryQuery({ type: "solutions", locale });
    const solution = (!isLoading && data && data.result) ? customData(data.data, "solutions") : null;


    useEffect(() => {
        if (!isPc) {
            setActiveIndex(0);
        } else {
            setActiveIndex(-1);
        }
        boxRefs.current.forEach((el) => {
            if (!el) return;
            el.style.height = "";
        });
    }, [isPc]);

    useEffect(() => {
        if (!solution || solution.length === 0) return;

        if (!isPc) {
            requestAnimationFrame(() => {
                boxRefs.current.forEach((el, i) => {
                    if (!el) return;

                    el.style.height =
                        i === activeIndex ? `${el.scrollHeight}px` : "0px";
                });
            });
        } else {
            boxRefs.current.forEach((el) => {
                if (!el) return;
                el.style.height = "";
            });
        }
    }, [activeIndex, isPc, solution]);

    const handleClick = (idx, item) => {
        if (isPc) {
            setSolutionDetail(item);
        } else {
            setActiveIndex(prev => (prev === idx ? -1 : idx));
        }
    };

    const handleEnter = (idx) => {
        if (isPc) setActiveIndex(idx);
    };

    const handleLeave = () => {
        if (isPc) setActiveIndex(-1);
    };

    const langData = useSelector(state => state.language.data);
    if(!langData) return null;

    const setSolutionDetail = (tabItem) => {
        const next = buildCateChange(solution, [], 0, tabItem.path);
        const nextPath = next.map((item) => item.path);
        const detailUrl = nextPath.join("/");
        router.push(`/solutions/detail/${detailUrl}`);
    };




    return(
        <>
            {
                solution && solution.length > 0 &&
                <Wrap $itemCount={solution.length}>
                    <div className={"solution-info-wrap"}>
                        {solution.map((item, i) => (
                            <div
                                key={i}
                                className={`solution-item ${activeIndex === i ? "active" : ""}`}
                                onMouseEnter={() => handleEnter(i)}
                                onMouseLeave={handleLeave}
                                onClick={() => handleClick(i, item)}
                            >
                                <div className="img-wrap">
                                    <img src={item?.imageUrl} alt={item.title}/>
                                </div>

                                <div className="text-wrap">
                                    <div className="title">
                                        {item.title}
                                        {
                                            isTablet &&
                                            <p
                                                className={"more-btn"}
                                                onClick={(e)=>{
                                                e.stopPropagation();
                                                setSolutionDetail(item)

                                                }}><span>이동하기</span><IoIosArrowRoundForward size={18}/></p>
                                        }
                                    </div>
                                    <div className={"sub-text"} ref={(el) => (boxRefs.current[i] = el)}>
                                        <div className={"text-inner"}>
                                            <div className={"sub-title"}>
                                                <p>{item.desc}</p>
                                            </div>
                                            {
                                                item.tags && item.tags.includes(",") ? (
                                                    <ul className="tag-wrap">
                                                        {
                                                            item.tags.split(",").map((tag, idx) => (
                                                                <li key={idx}>{tag}</li>
                                                            ))
                                                        }
                                                    </ul>
                                                ) : (
                                                    <>{item.tags}</>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Wrap>
            }
        </>

    );
};
const Wrap = styled.div`
    .solution-info-wrap {
        .solution-item {
            position: relative;
            width: 100%;
            height: 100px;
            overflow: hidden;
            transition: height .3s ease;
            cursor: pointer;
            .img-wrap {
                position: relative;
                height: 100%;
                transition: all 2.5s cubic-bezier(0, 1, .34, .99);
                
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .text-wrap {
                position: absolute;
                bottom: 30px;
                padding: 0 20px;
                width: 100%;
                .title {
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 29px;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .more-btn{
                        opacity: 0;
                        visibility: hidden;
                        transition: all .2s;
                        width: 81px;
                        height: 22px;
                        background: rgba(0, 0, 0, 0.2);
                        border: 1px solid #FFFFFF;
                        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                        backdrop-filter: blur(6px);
                        border-radius: 99px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 3px;
                        span{
                            font-weight: 500;
                            font-size: 12px;
                            line-height: 14px;
                            letter-spacing: -0.04em;
                            color: #FFFFFF;
                        }
                    }
                }
                .sub-text {
                    height: 0;
                    overflow: hidden;
                    transition: height .3s ease;
                    &  > * {
                        overflow: hidden;
                    }
                    .text-inner{
                        overflow: hidden;
                        .sub-title{
                            font-weight: 600;
                            font-size: 14px;
                            line-height: 17px;
                            color: #FFFFFF;
                        }
                        .tag-wrap{
                            display: flex;
                            gap: 5px;
                            align-items: center;
                            flex-wrap: wrap;
                            padding-top: 20px;
                            li{
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding: 4px 12px;
                                height: 22px;
                                background: rgba(0, 0, 0, 0.2);
                                border: 1px solid #FFFFFF;
                                box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                                backdrop-filter: blur(6px);
                                border-radius: 99px;
                                font-weight: 500;
                                font-size: 12px;
                                line-height: 14px;
                                letter-spacing: -0.04em;
                                color: #FFFFFF;
                                gap: 5px;
                            }
                        }
                    }
                }
            }
            &.active {
                height: 300px;
                .title {
                    .more-btn {
                        opacity: 1;
                        visibility: visible;
                    }
                }
            }
        }
    }

    @media (min-width: ${SIZES.TABLET_L}) {
        .solution-info-wrap {
            display: flex;
            height: calc(100vh - 80px);
            .solution-item {
                width: ${(props) => `${parseInt(100 / props?.$itemCount)}%`};
                height: 100%;
                transition: all 1.5s cubic-bezier(0,1,.34,.99);
                flex:1;
                will-change: flex-basis;
                cursor: pointer;
                .text-wrap {
                    position: absolute;
                    bottom: 40px;
                    .title {
                        font-size: 52px;
                        transition: font-size .6s cubic-bezier(0,1,.34,.99);
                        line-height: 62px;
                    }
                    .sub-text {
                        height: auto;
                        font-weight: 300;
                        transition: all .6s cubic-bezier(0,1,.34,.99);
                        display: grid;
                        grid-template-rows: 0fr;
                        will-change: grid-template-rows;
                        .text-inner{
                            .sub-title{
                                font-size: 40px;
                                line-height: 48px;
                            }
                            .tag-wrap{
                                padding-top: 30px;
                                gap: 10px;
                                li{
                                    padding: 8px 12px;
                                    backdrop-filter: blur(6px);
                                    border-radius: 99px;
                                    font-size: 14px;
                                    line-height: 17px;
                                    color: #FFFFFF;
                                }
                            }
                        }
                    }
                }
                &.active {
                    flex-basis: ${(props) => `${parseInt(100 / props?.$itemCount)}%`};
                    height: 100%;
                    .text-wrap {
                        .title{
                            font-size: 72px;
                            line-height: 86px;
                        }
                        .sub-text {
                            grid-template-rows: 1fr;
                        }
                    }
                }
            }
        }
    }

`;
export default SolutionClient;